import { render, staticRenderFns } from "./SlideHero.vue?vue&type=template&id=cda17ef8&scoped=true&"
import script from "./SlideHero.vue?vue&type=script&lang=js&"
export * from "./SlideHero.vue?vue&type=script&lang=js&"
import style0 from "./SlideHero.vue?vue&type=style&index=0&id=cda17ef8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda17ef8",
  null
  
)

export default component.exports